'use strict';

angular.module('rmRole')
    .controller('RoleOverviewCtrl', require('./role_overview_ctrl'))
    .controller('RoleFormCtrl', require('./role_form_ctrl'));
